import React, { Component } from 'react';
//import logo from './logo.svg';
import ear from './ear_256x256.png';
//import couchcast_logo from './couchcast_logo.png';

import { Link } from "react-router-dom";

import './Listen.css';

class Listen extends Component {
  render() {

    const audioPlayerStyle ={
      visibility:'none'
    }
    const listenStyle ={
      display:'none',
      marginRight: 'auto',
      marginLeft: 'auto'
    }
    const pauseStyle ={
      display:'block',
      marginRight: 'auto',
      marginLeft: 'auto'
    }
    
    function handleVolumeUpClick(e) {
      e.preventDefault();
      var vol = parseFloat(document.getElementById('player').volume);
      console.log('The volume up link was clicked.',vol);
      if(vol<1){
        vol = Math.round((vol+.1) * 10) / 10;
        document.getElementById('player').volume=vol;
      }
    }
    
    function handleVolumeDownClick(e) {
      e.preventDefault();
      var vol = parseFloat(document.getElementById('player').volume);
      console.log('The volume down link was clicked.',vol);
      if(vol>0){
        vol = Math.round((vol-.1) * 10) / 10;
        document.getElementById('player').volume=vol;
      }
    }
    function handleListenClick(e) {
      e.preventDefault();
      console.log('The play link was clicked.');
      document.getElementById('player').play();
      document.getElementById('pauseInput').style.display = "block";
      document.getElementById('listenInput').style.display = "none";
    }
    function handlePauseClick(e) {
      e.preventDefault();
      document.getElementById('pauseInput').style.display = "none";
      document.getElementById('listenInput').style.display = "block";
      console.log('The pause link was clicked.');
      document.getElementById('player').pause();
    }
    
    function focusedInput(e){
      
      if(e.target.value === "Giants vs. Eagles"){
        e.target.value = "";
      }
    }

    function searchBoxChanged(e){
      //e.preventDefault();
      var newvalue = e.target.value.toString();
      console.log('The search now says: ',newvalue);
      //document.getElementById("inputBroadcastSearchBox").value = newvalue;
    }


    return (
      <div className="Listen">
        <header className="Listen-header">
          <input id="inputListenSearchBox" className="Listen-searchBox" onFocus={focusedInput} onChange={searchBoxChanged} defaultValue="Giants vs. Eagles"></input>
            <h1 className="Listen-title">You have chosen to Listen to</h1>
            <button onClick={handleVolumeUpClick}>Volume Up</button>
            <button onClick={handleVolumeDownClick}>Volume Down</button>
        </header>
        <article>
        <audio id="player" style={audioPlayerStyle} src="http://5.189.154.249:8050/stream" preload="none" autoPlay="true"></audio>
          <img src={ear} className="Listen-ear" alt="ear" />
        </article>
        <p className="Listen-intro">
          
        </p>
        <footer className="footer">
          <div className="Listen-footer">
            <button className="btn-footer" style={listenStyle} id="listenInput" onClick={handleListenClick}>Listen</button>
            <button className="btn-footer" style={pauseStyle} id="pauseInput" onClick={handlePauseClick}>Pause</button>
          </div>
          
          <Link to={`/Home/`} className="btn-footer-home back-btn">Back</Link>
        </footer>
      </div>
    );
  }
}

export default Listen;



// WEBPACK FOOTER //
// ./src/components/Listen.js